import { Button } from 'antd';
import Form from '@arivaa-react/components/form';
import { DeleteOutlined } from '@ant-design/icons';

export function EditHeaderNavigation() {
  const handleSubmit = async (values) => {
    console.log(values);
  };
  return (
    <div className="card navigation">
      <div className="heading">
        <p className="label">Edit Navigation</p>
        <div className="actions">
          <Button type="primary">Add Item</Button>
        </div>
      </div>
      <div className="edit-form">
        <Form
          renderForm={({ renderElement }) => {
            return (
              <div>
                <div className="item inline">
                  {renderElement({
                    type: 'text',
                    name: 'title',
                    label: 'Title',
                    required: true,
                    options: {
                      initialValue: 'Home',
                    },
                  })}
                  {renderElement({
                    type: 'select',
                    name: 'type',
                    label: 'On click open',
                    required: true,
                    data: [
                      'Page',
                      'Link',
                      'Multi Column Dropdown',
                      'Single Column Dropdown',
                    ],
                    options: {
                      initialValue: 'Page',
                    },
                  })}
                  {renderElement({
                    type: 'select',
                    name: 'type',
                    label: 'Select Page',
                    required: true,
                    data: ['Page 1', 'Page 2'],
                    options: {
                      initialValue: 'Page 1',
                    },
                  })}
                  <div className="action">
                    <Button danger shape="circle" icon={<DeleteOutlined />} />
                  </div>
                </div>
                <div className="item inline">
                  {renderElement({
                    type: 'text',
                    name: 'title',
                    label: 'Title',
                    required: true,
                    options: {
                      initialValue: 'About',
                    },
                  })}
                  {renderElement({
                    type: 'select',
                    name: 'type',
                    label: 'On click open',
                    required: true,
                    data: [
                      'Page',
                      'Link',
                      'Multi Column Dropdown',
                      'Single Column Dropdown',
                    ],
                    options: {
                      initialValue: 'Link',
                    },
                  })}
                  {renderElement({
                    type: 'text',
                    name: 'title',
                    label: 'Enter Link',
                    required: true,
                    options: {
                      initialValue:
                        'https://dental-website-psi.vercel.app/home',
                    },
                  })}
                  <div className="action">
                    <Button danger shape="circle" icon={<DeleteOutlined />} />
                  </div>
                </div>
                <div className="item inline">
                  {renderElement({
                    type: 'text',
                    name: 'title',
                    label: 'Title',
                    required: true,
                    options: {
                      initialValue: 'Home',
                    },
                  })}
                  {renderElement({
                    type: 'select',
                    name: 'type',
                    label: 'On click open',
                    required: true,
                    data: [
                      'Page',
                      'Link',
                      'Multi Column Dropdown',
                      'Single Column Dropdown',
                    ],
                    options: {
                      initialValue: 'Multi Column Dropdown',
                    },
                  })}
                  <div className="action">
                    <Button danger shape="circle" icon={<DeleteOutlined />} />
                  </div>
                </div>
                <div className="dropdown-form">
                  <div className="dropdown-column">
                    <div className="heading">
                      {renderElement({
                        type: 'text',
                        name: 'title',
                        label: 'Column Title',
                        required: true,
                        options: {
                          initialValue: 'About',
                        },
                      })}
                      <div className="action">
                        <Button type="primary">Add Item</Button>
                        <Button danger>Delete</Button>
                      </div>
                    </div>
                    <div className="list">
                      <div className="item inline">
                        {renderElement({
                          type: 'text',
                          name: 'title',
                          label: 'Title',
                          required: true,
                          options: {
                            initialValue: 'About',
                          },
                        })}
                        {renderElement({
                          type: 'select',
                          name: 'type',
                          label: 'On click open',
                          required: true,
                          data: ['Page', 'Link'],
                          options: {
                            initialValue: 'Link',
                          },
                        })}
                        {renderElement({
                          type: 'select',
                          name: 'type',
                          label: 'Select Page',
                          required: true,
                          data: ['Page 1', 'Page 2'],
                          options: {
                            initialValue: 'Page 1',
                          },
                        })}
                        <div className="action">
                          <Button
                            danger
                            shape="circle"
                            icon={<DeleteOutlined />}
                          />
                        </div>
                      </div>
                      <div className="item inline">
                        {renderElement({
                          type: 'text',
                          name: 'title',
                          label: 'Title',
                          required: true,
                          options: {
                            initialValue: 'About',
                          },
                        })}
                        {renderElement({
                          type: 'select',
                          name: 'type',
                          label: 'On click open',
                          required: true,
                          data: ['Page', 'Link'],
                          options: {
                            initialValue: 'Link',
                          },
                        })}
                        {renderElement({
                          type: 'text',
                          name: 'title',
                          label: 'Enter Link',
                          required: true,
                          options: {
                            initialValue:
                              'https://dental-website-psi.vercel.app/home',
                          },
                        })}
                        <div className="action">
                          <Button
                            danger
                            shape="circle"
                            icon={<DeleteOutlined />}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="dropdown-column">
                    <div className="heading">
                      {renderElement({
                        type: 'text',
                        name: 'title',
                        label: 'Column Title',
                        required: true,
                        options: {
                          initialValue: 'About',
                        },
                      })}
                      <div className="action">
                        <Button type="primary">Add Item</Button>
                        <Button danger>Delete</Button>
                      </div>
                    </div>
                    <div className="list">
                      <div className="item inline">
                        {renderElement({
                          type: 'text',
                          name: 'title',
                          label: 'Title',
                          required: true,
                          options: {
                            initialValue: 'About',
                          },
                        })}
                        {renderElement({
                          type: 'select',
                          name: 'type',
                          label: 'On click open',
                          required: true,
                          data: ['Page', 'Link'],
                          options: {
                            initialValue: 'Link',
                          },
                        })}
                        {renderElement({
                          type: 'select',
                          name: 'type',
                          label: 'Select Page',
                          required: true,
                          data: ['Page 1', 'Page 2'],
                          options: {
                            initialValue: 'Page 1',
                          },
                        })}
                        <div className="action">
                          <Button
                            danger
                            shape="circle"
                            icon={<DeleteOutlined />}
                          />
                        </div>
                      </div>
                      <div className="item inline">
                        {renderElement({
                          type: 'text',
                          name: 'title',
                          label: 'Title',
                          required: true,
                          options: {
                            initialValue: 'About',
                          },
                        })}
                        {renderElement({
                          type: 'select',
                          name: 'type',
                          label: 'On click open',
                          required: true,
                          data: ['Page', 'Link'],
                          options: {
                            initialValue: 'Link',
                          },
                        })}
                        {renderElement({
                          type: 'text',
                          name: 'title',
                          label: 'Enter Link',
                          required: true,
                          options: {
                            initialValue:
                              'https://dental-website-psi.vercel.app/home',
                          },
                        })}
                        <div className="action">
                          <Button
                            danger
                            shape="circle"
                            icon={<DeleteOutlined />}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item inline">
                  {renderElement({
                    type: 'text',
                    name: 'title',
                    label: 'Title',
                    required: true,
                    options: {
                      initialValue: 'About',
                    },
                  })}
                  {renderElement({
                    type: 'select',
                    name: 'type',
                    label: 'On click open',
                    required: true,
                    data: [
                      'Page',
                      'Link',
                      'Multi Column Dropdown',
                      'Single Column Dropdown',
                    ],
                    options: {
                      initialValue: 'Link',
                    },
                  })}
                  {renderElement({
                    type: 'text',
                    name: 'title',
                    label: 'Enter Link',
                    required: true,
                    options: {
                      initialValue:
                        'https://dental-website-psi.vercel.app/home',
                    },
                  })}
                  <div className="action">
                    <Button danger shape="circle" icon={<DeleteOutlined />} />
                  </div>
                </div>
              </div>
            );
          }}
          onSubmit={handleSubmit}
          submitButtonProps={{
            children: 'Save',
          }}
        />
      </div>
    </div>
  );
}
